<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Artículos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar()">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="blue mx-1" fab small dark @click.native="exportarMovimientosExcel()">
              <v-icon v-bind="attrs" v-on="on">mdi-file-excel-outline</v-icon>
            </v-btn>
          </template>
          <span> Exportar Movimientos </span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="green mx-1" fab small dark @click.native="exportarArticulosExcel()">
              <v-icon v-bind="attrs" v-on="on">mdi-file-excel-outline</v-icon>
            </v-btn>
          </template>
          <span> Exportar Artículos </span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="red mx-1" fab small dark @click.native="$refs.file_input_articulos.click()">
              <v-icon v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
            </v-btn>
            <input type="file" style="display: none" ref="file_input_articulos" accept=".xlsx, .odt"
              @change="importarArticulosExcel($event)" />
          </template>
          <span> Importar Artículos </span>
        </v-tooltip>

        <v-btn class="deep-orange darken-3 mx-1" fab small dark @click.native="abrirNuevoArticulo">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers_articulos" :items="articulos" :items-per-page="50" sort-by="cliente.codigo"
        :search="filtros_articulos.otros" item-key="_id" class="elevation-1" :footer-props="{
          itemsPerPageOptions: [15, 50, 100, -1],
        }">
        <template v-slot:top>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs2 sm2 md2>
                <v-text-field v-model="filtros_articulos.codigo_cliente" type="number"
                  label="Cód. Cliente"></v-text-field>
              </v-flex>
              <v-flex xs3 sm3 md3>
                <v-text-field v-model="filtros_articulos.otros" append-icon="search"
                  label="Cód. Barras, Sku, referencia o nombre" single-line hide-details></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 md3>
                <v-dialog ref="dialogMovimientoFiltroPrincipalFechaInicio"
                  v-model="dialogMovimientoFiltroPrincipalFechaInicio"
                  :return-value.sync="filtroPrincipalMovimientoFechaInicio" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filtroPrincipalMovimientoFechaInicioFormateada" label="Fecha inicio"
                      prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="filtroPrincipalMovimientoFechaInicio" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary"
                      @click="dialogMovimientoFiltroPrincipalFechaInicio = false">Cancelar</v-btn>
                    <v-btn text color="primary"
                      @click="$refs.dialogMovimientoFiltroPrincipalFechaInicio.save(filtroPrincipalMovimientoFechaInicio)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 sm3 md3>
                <v-dialog ref="dialogMovimientoFiltroPrincipalFechaFin" v-model="dialogMovimientoFiltroPrincipalFechaFin"
                  :return-value.sync="filtroPrincipalMovimientoFechaFin" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filtroPrincipalMovimientoFechaFinFormateada" label="Fecha fin"
                      prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="filtroPrincipalMovimientoFechaFin" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialogMovimientoFiltroPrincipalFechaFin = false">Cancelar</v-btn>
                    <v-btn text color="primary"
                      @click="$refs.dialogMovimientoFiltroPrincipalFechaFin.save(filtroPrincipalMovimientoFechaFin)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltrosArticulos()" color="red">clear</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.cod_barras="{ item }">
          {{ item.cod_barras }}
          <v-icon class="ml-2" @click="imprimirCodigoBarras(item)" color="black">
            mdi-barcode
          </v-icon>
        </template>
        <template v-slot:item.disponible="{ item }">
          <v-chip :color="getColorExistenciasDisponibles(item)" dark>{{
            item.existencias - item.solicitado
          }}</v-chip>
        </template>
        <template v-slot:item.existencias="{ item }">
          {{ item.existencias }}
          <v-icon v-if="esAdministrador" class="ml-2" @click="abrirExistenciasArticulos(item)" color="black">
            edit
          </v-icon>
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon small class="mr-2" @click="editarItem(item)">edit</v-icon>
          <v-icon small class="mr-2" @click="eliminarItem(item)">delete</v-icon>
          <v-icon small class="mr-2" @click="abrirMovimientos(item)"> mdi-eye </v-icon>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog_articulo" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="articulo.nombre" label="*Nombre" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="articulo.cod_cliente" label="*Cód.Cli" type="Number" min="1" step="1"
                    :readonly="editando || eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-text-field v-model="articulo.sku_interno" label="*Sku interno" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-text-field v-model="articulo.sku_cliente" label="*Sku cliente" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="articulo.cod_barras" label="*Código de barras"
                    :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.existencias" label="Existencias" type="Number" min="0" step="1"
                    readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.minimo" label="*Mínimo" type="Number" min="0" step="1"
                    :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.precio_neto" label="*Precio" type="Number" min="0"
                    :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select v-model="articulo.tipoPale" :items="['Americano', 'Europeo', 'Otro']" label="*Palé"
                    :readonly="eliminando"></v-select>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.nUnidadesPorPale" label="*u/palé" type="Number" min="0"
                    :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
                  <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogoArticulo">Cancelar</v-btn>
            <v-btn v-if="creando" color="primary darken-1" @click="insertar">Insertar</v-btn>
            <v-btn v-else-if="editando" color="primary darken-1" @click="actualizar">Actualizar</v-btn>
            <v-btn v-else color="primary darken-1" @click="eliminar">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_existencias_articulo" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Editar existencias</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field v-model="articulo.existencias" label="Existencias" type="Number" min="0"
                    step="1"></v-text-field>
                </v-flex>
                <v-flex xs12 sm9 md9>
                  <v-text-field v-model="observaciones" label="Observaciones (del movimiento)" type="text"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogoExistenciasArticulo">Cancelar</v-btn>
            <v-btn color="primary darken-1" @click="actualizarExistencias">Actualzar y Registrar Movimiento</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogoCodigoBarras" max-width="500px">
        <barcode id="vue-barcode-element" :value="barcodeValue" height="20">
          No se ha cargado el código de barras
        </barcode>
      </v-dialog>

      <v-dialog v-model="dialog_movimiento" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-card-title>
            <span class="headline">Movimientos de {{ articulo.nombre }}</span>
          </v-card-title>
          <v-divider class="mx-2" inset horizonatal></v-divider>
          <v-card-text>
            <v-data-table :headers="headers_movimientos" :items="movimientos" :items-per-page="50"
              :search="filtros_movimientos.otros" item-key="_id" class="elevation-1">
              <template v-slot:top>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs6 sm3 md3>
                      <v-dialog ref="dialog_movimiento_filtro_fecha_inicio"
                        v-model="dialog_movimiento_filtro_fecha_inicio"
                        :return-value.sync="filtro_remoto_movimiento_fecha_inicio" persistent width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="filtro_remoto_movimiento_fecha_inicio_formateada" label="Fecha inicio"
                            prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="filtro_remoto_movimiento_fecha_inicio"
                          :max="movimientos_fecha_inicio_maxima" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary"
                            @click="dialog_movimiento_filtro_fecha_inicio = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="
                            $refs.dialog_movimiento_filtro_fecha_inicio.save(
                              filtro_remoto_movimiento_fecha_inicio
                            )
                            ">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                      <v-dialog ref="dialog_movimiento_filtro_fecha_fin" v-model="dialog_movimiento_filtro_fecha_fin"
                        :return-value.sync="filtro_remoto_movimiento_fecha_fin" persistent width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="filtro_remoto_movimiento_fecha_fin_formateada" label="Fecha fin"
                            prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="filtro_remoto_movimiento_fecha_fin" :min="movimientos_fecha_fin_minima"
                          :max="movimientos_fecha_fin_maxima" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dialog_movimiento_filtro_fecha_fin = false">Cancelar</v-btn>
                          <v-btn text color="primary"
                            @click="$refs.dialog_movimiento_filtro_fecha_fin.save(filtro_remoto_movimiento_fecha_fin)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs11 sm4 md4>
                      <v-text-field v-model="filtros_movimientos.otros" append-icon="search" label="Nombre usuario, email"
                        single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-icon class="mt-2" @click="limpiarFiltrosMovimientos()" color="red">clear</v-icon>
                    </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-btn class="green mx-1" fab small dark @click.native="exportarMovimientosExcel()">
                        <v-icon>mdi-file-excel-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </template>

              <template v-slot:item.creacion="{ item }">
                {{ formatearFecha(new Date(item.creacion).toISOString().substring(0, 10)) }}
              </template>
              <template v-slot:item.estado_antes="{ item }">
                <v-icon :color="getColorEstado(item.estado_antes)" dark>{{
                  getIconEstado(item.estado_antes)
                }}</v-icon>
              </template>
              <template v-slot:item.estado_despues="{ item }">
                <v-icon :color="getColorEstado(item.estado_despues)" dark>
                  {{ getIconEstado(item.estado_despues) }}
                </v-icon>
              </template>
              <!-- <template v-slot:item.accion="{ item }">
                <v-icon small class="mr-2" @click="editarMovimiento(item)">edit</v-icon>
              </template>-->
            </v-data-table>
            <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
              <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogMovimiento">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";
import Vue from "vue";
import VueBarcode from "vue-barcode";
Vue.component("barcode", VueBarcode);

const CREANDO = 1;
const EDITANDO = 2;
const ELIMINANDO = 3;

export default {
  data() {
    return {
      barcodeValue: "",
      dialogoCodigoBarras: false,
      dialog_articulo: false,
      dialog_existencias_articulo: false,
      dialog_movimiento: false,
      filtros_articulos: {
        codigo_cliente: "",
        otros: "",
      },
      dialogMovimientoFiltroPrincipalFechaInicio: false,
      dialogMovimientoFiltroPrincipalFechaFin: false,
      filtroPrincipalMovimientoFechaInicio: null,
      filtroPrincipalMovimientoFechaInicioFormateada: null,
      filtroPrincipalMovimientoFechaFin: null,
      filtroPrincipalMovimientoFechaFinFormateada: null,

      dialog_movimiento_filtro_fecha_inicio: false,
      dialog_movimiento_filtro_fecha_fin: false,
      filtro_remoto_movimiento_fecha_inicio: null,
      filtro_remoto_movimiento_fecha_inicio_formateada: null,
      filtro_remoto_movimiento_fecha_fin: null,
      filtro_remoto_movimiento_fecha_fin_formateada: null,
      filtros_movimientos: {
        otros: "",
      },
      estados: {
        SOLICITADO: 1,
        SOLICITADO_SIN_STOCK: 2,
        PREPARANDO: 3,
        EMPAQUETADO: 4,
        EMBARCADO: 5,
        CANCELADO: 6,
        INCIDENCIA: 7,
      },
      articulos: [],
      movimientos: [],
      headers_articulos: [
        {
          text: "Cód. Cliente",
          value: "cliente.codigo",
          align: "center",
          sortable: true,
          filter: (value) => {
            if (!this.filtros_articulos.codigo_cliente) {
              return true;
            }
            return value == parseInt(this.filtros_articulos.codigo_cliente);
          },
        },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Cód. Barras", value: "cod_barras", sortable: true, filterable: true, },
        { text: "Sku interno", value: "sku_interno", sortable: true },
        { text: "Sku cliente", value: "sku_cliente", sortable: true },
        { text: "Disponible", value: "disponible", sortable: true, filterable: false, },
        { text: "Existencias", value: "existencias", sortable: true, filterable: false, },
        { text: "Solicitado", value: "solicitado", sortable: true, filterable: false, },
        { text: "Mínimo", value: "minimo", sortable: true, filterable: false },
        { text: "Precio", value: "precio_neto", sortable: true, filterable: false, },
        { text: "U/Palé", value: "nUnidadesPorPale", sortable: false, filterable: false, },
        { text: "Acciones", value: "accion", align: "center", sortable: false, filterable: false, },
      ],
      headers_movimientos: [
        { text: "Fecha", value: "creacion", sortable: true, filterable: false, },
        { text: "Rol usuario", value: "usuario.rol", sortable: false },
        { text: "Nombre usuario", value: "usuario.nombre", sortable: false },
        { text: "Email usuario", value: "usuario.email", sortable: false },
        { text: "Ref. Albarán", value: "albaran.cod_albaran", sortable: false, },
        { text: "Ref. Picking", value: "picking_y_packing.ref_cliente", sortable: false, },
        { text: "Antes", value: "estado_antes", sortable: false, filterable: false, },
        { text: "Después", value: "estado_despues", sortable: false, filterable: false, },
        { text: "Variación", value: "variacion", sortable: false, filterable: false, },
        { text: "Existencias", value: "existencias", sortable: false, filterable: false, },
        { text: "Tipo Palé", value: "articulo.tipoPale", sortable: false, filterable: false, },
        { text: "Nº Palés Usados", value: "nPalesUsados", sortable: false, filterable: false, },
        { text: "Observaciones", value: "observaciones", sortable: false, filterable: false, },
        // {
        //   text: "Acciones",
        //   value: "accion",
        //   align: "center",
        //   sortable: false,
        //   filterable: false
        // }
      ],
      articulo: {
        _id: "",
        cod_cliente: "",
        sku_interno: "",
        sku_cliente: "",
        cod_barras: "",
        nombre: "",
        existencias: 0,
        solicitado: "",
        minimo: "",
        precio_neto: "",
        tipoPale: "",
        nUnidadesPorPale: 0,
        creacion: "",
      },
      observaciones: "",
      validaMensaje: [],
      accion: CREANDO,
    };
  },
  computed: {
    esAdministrador() {
      return this.$store.state.usuario.rol == "Administrador";
    },
    formTitle() {
      console.log(
        "formTitle this.creando",
        this.creando
          ? "Nuevo registro"
          : this.eliminando
            ? "Eliminar registro"
            : "Editar registro"
      );
      switch (this.accion) {
        case CREANDO:
          return "Nuevo registro";
        case EDITANDO:
          return "Editar registro";
        case ELIMINANDO:
          return "Eliminar registro";
      }
      console.log("No coge el switch");
      return this.creando
        ? "Nuevo registro"
        : this.eliminando
          ? "Eliminar registro"
          : "Editar registro";
    },
    creando() {
      console.log("creando this.accion", this.accion);
      console.log("CREANDO", CREANDO);
      return this.accion == CREANDO;
    },
    editando() {
      console.log("editando this.accion", this.accion);
      console.log("EDITANDO", EDITANDO);
      return this.accion == EDITANDO;
    },
    eliminando() {
      console.log("eliminando this.accion", this.accion);
      console.log("ELIMINANDO", ELIMINANDO);
      return this.accion == ELIMINANDO;
    },
    filtroPrincipalFechaInicioInicial() {
      const fechaActual = new Date();
      const mesAnterior = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - 1, 1);

      const anio = mesAnterior.getFullYear();
      const mes = String(mesAnterior.getMonth() + 1).padStart(2, '0');
      const dia = String(mesAnterior.getDate()).padStart(2, '0');

      const resultado = `${anio}-${mes}-${dia}`;

      console.log(resultado);
      return resultado;
    },
    filtroPrincipalFechaFinInicial() {
      const fechaActual = new Date();
      fechaActual.setDate(0); // Establecer el día en 0 para obtener el último día del mes anterior
      const resultado = fechaActual.toISOString().substring(0, 10);
      console.log('filtroPrincipalFechaFinInicial resultado', resultado);
      return resultado;
    },
    movimientos_fecha_fin_maxima() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate());
      return fecha.toISOString().substring(0, 10);
    },
    movimientos_fecha_inicio_inicial() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate() - 14);
      return fecha.toISOString().substring(0, 10);
    },
    movimientos_fecha_inicio_maxima() {
      let hoy = new Date();
      hoy.setDate(new Date().getDate());
      console.log("hoy", hoy.toISOString().substring(0, 10));
      console.log(
        "this.filtro_remoto_movimiento_fecha_fin",
        this.filtro_remoto_movimiento_fecha_fin
      );
      let fecha =
        hoy.toISOString().substring(0, 10) < this.filtro_remoto_movimiento_fecha_fin
          ? hoy.toISOString().substring(0, 10)
          : this.filtro_remoto_movimiento_fecha_fin;
      console.log("movimientos_fecha_inicio_maxima", fecha);
      return fecha;
    },
    movimientos_fecha_fin_minima() {
      return this.filtro_remoto_movimiento_fecha_inicio;
    },
    movimientos_fecha_fin_maxima() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate());
      return fecha.toISOString().substring(0, 10);
    },
  },
  watch: {
    dialog_articulo(val) {
      val || this.cerrarDialogoArticulo();
    },
    dialog_movimiento(val) {
      val || this.cerrarDialogMovimiento();
    },
    dialog_existencias_articulo(val) {
      val || this.cerrarDialogoExistenciasArticulo();
    },
    filtroPrincipalMovimientoFechaInicio(val) {
      console.log("filtroPrincipalMovimientoFechaInicio", val);
      this.filtroPrincipalMovimientoFechaInicioFormateada = this.formatearFecha(val);
    },
    filtroPrincipalMovimientoFechaFin(val) {
      console.log("filtroPrincipalMovimientoFechaFin", val);
      this.filtroPrincipalMovimientoFechaFinFormateada = this.formatearFecha(val);
    },
    filtro_remoto_movimiento_fecha_inicio(val) {
      console.log("filtro_remoto_movimiento_fecha_inicio", val);
      this.filtro_remoto_movimiento_fecha_inicio_formateada = this.formatearFecha(val);
      this.listarMovimientos();
    },
    filtro_remoto_movimiento_fecha_fin(val) {
      console.log("filtro_remoto_movimiento_fecha_inicio", val);
      this.filtro_remoto_movimiento_fecha_fin_formateada = this.formatearFecha(val);
      console.log(
        "filtro_remoto_movimiento_fecha_fin_formateada",
        this.filtro_remoto_movimiento_fecha_fin_formateada
      );
      this.listarMovimientos();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      if (val.length > 0 && !this.dialog_articulo && !this.dialog_movimiento) {
        this.$alert(val[0]);
      }
    },
  },
  created() {
    this.filtroPrincipalMovimientoFechaInicio = this.filtroPrincipalFechaInicioInicial;
    this.filtroPrincipalMovimientoFechaFin = this.filtroPrincipalFechaFinInicial;
    this.listar();
  },
  methods: {
    formatearFecha(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    getColorExistenciasDisponibles(articulo) {
      if (articulo.existencias - articulo.solicitado > articulo.minimo) {
        return "green";
      } else if (articulo.existencias - articulo.solicitado > 0) {
        return "orange";
      } else {
        return "red";
      }
    },
    limpiarFiltrosArticulos() {
      console.log("limpiarFiltrosArticulos");
      this.filtroPrincipalMovimientoFechaInicio = "";
      this.filtroPrincipalMovimientoFechaFin = "";
      this.filtros_articulos.codigo_cliente = "";
      this.filtros_articulos.otros = "";
    },
    limpiarFiltrosMovimientos() {
      console.log("limpiarFiltrosMovimientos");
      this.filtros_movimientos.otros = "";
    },
    listar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("articulo/list", configuracion)
        .then(function (response) {
          me.validaMensaje = [];
          me.articulos = response.data;
          console.log("me.articulos", me.articulos);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    abrirNuevoArticulo() {
      this.validaMensaje = [];
      this.dialog_articulo = true;
    },
    abrirExistenciasArticulos(item) {
      this.articulo = Object.assign({}, item);
      this.dialog_existencias_articulo = true;
    },
    limpiar() {
      this.articulo = {
        _id: "",
        cod_cliente: "",
        sku_interno: "",
        sku_cliente: "",
        cod_barras: "",
        nombre: "",
        existencias: 0,
        solicitado: "",
        minimo: "",
        precio_neto: "",
        tipoPale: "",
        nUnidadesPorPale: 0,
        creacion: "",
      };
      this.observaciones = "";
      this.validaMensaje = [];
      this.accion = CREANDO;
      this.movimientos = [];
    },
    esValido() {
      this.validaMensaje = [];
      if (
        isNaN(this.articulo.cod_cliente) ||
        this.articulo.cod_cliente != parseInt(this.articulo.cod_cliente)
      ) {
        this.validaMensaje.push("Código Cliente (Número entero de hasta 6 dígitos)");
      }
      if (!this.articulo.sku_interno) {
        this.validaMensaje.push("Sku interno del artículo (texto entre 1-20 caracteres)");
      }
      if (!this.articulo.sku_cliente) {
        this.validaMensaje.push("Sku cliente del artículo (texto entre 1-20 caracteres)");
      }
      if (!this.articulo.nombre) {
        this.validaMensaje.push("Nombre del artículo (texto entre 1-64 caracteres)");
      }
      if (this.articulo.minimo === "" || isNaN(this.articulo.minimo)) {
        this.validaMensaje.push("Stock mín del artículo (nº entero >= 0)");
      }
      if (this.articulo.precio_neto === "" || isNaN(this.articulo.precio_neto)) {
        this.validaMensaje.push("Precio neto (importe >= 0)");
      }
      return this.validaMensaje.length == 0;
    },
    editarItem(item) {
      console.log("editar", item);
      this.articulo._id = item._id;
      if (item.cliente) {
        this.articulo.cod_cliente = item.cliente.codigo;
      }
      this.articulo.sku_interno = item.sku_interno;
      this.articulo.sku_cliente = item.sku_cliente;
      this.articulo.cod_barras = item.cod_barras;
      this.articulo.nombre = item.nombre;
      this.articulo.existencias = item.existencias;
      this.articulo.minimo = item.minimo;
      this.articulo.precio_neto = item.precio_neto;
      this.articulo.tipoPale = item.tipoPale;
      this.articulo.nUnidadesPorPale = item.nUnidadesPorPale;
      this.validaMensaje = [];
      this.dialog_articulo = true;
      this.accion = EDITANDO;
    },
    eliminarItem(item) {
      this.editarItem(item);
      this.accion = ELIMINANDO;
    },
    insertar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .post(
          "articulo/add",
          {
            cod_cliente: this.articulo.cod_cliente,
            sku_interno: this.articulo.sku_interno,
            sku_cliente: this.articulo.sku_cliente,
            cod_barras: this.articulo.cod_barras,
            nombre: this.articulo.nombre,
            existencias: this.articulo.existencias,
            minimo: this.articulo.minimo,
            precio_neto: this.articulo.precio_neto,
            tipoPale: this.articulo.tipoPale,
            nUnidadesPorPale: this.articulo.nUnidadesPorPale,
          },
          configuracion
        )
        .then(function (response) {
          console.log("response", response);
          me.limpiar();
          me.cerrarDialogoArticulo();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    insertarMuchos(cod_cliente, articulos) {
      console.log("insertarMuchos cod_cliente", cod_cliente);
      console.log("insertarMuchos articulos", articulos);
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post("articulo/crearMuchos", { cod_cliente, articulos }, configuracion)
        .then(function (response) {
          console.log("insertarMuchos response", response);
          me.validaMensaje = [];
          me.validaMensaje.push(
            "Creados TODOS (" + response.data.length + ") los artículos."
          );
          setTimeout(() => {
            me.limpiar();
            me.cerrarDialogoArticulo();
            me.listar();
          }, 2000);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
            if (error.response.data.code != 40001) {
              msj_error = msj_error + " ";
              setTimeout(() => {
                me.listar();
              }, 2000);
            }
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .put(
          "articulo/update",
          {
            _id: this.articulo._id,
            cod_cliente: this.articulo.cod_cliente,
            sku_interno: this.articulo.sku_interno,
            sku_cliente: this.articulo.sku_cliente,
            cod_barras: this.articulo.cod_barras,
            nombre: this.articulo.nombre,
            existencias: this.articulo.existencias,
            minimo: this.articulo.minimo,
            precio_neto: this.articulo.precio_neto,
            tipoPale: this.articulo.tipoPale,
            nUnidadesPorPale: this.articulo.nUnidadesPorPale,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          me.cerrarDialogoArticulo();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    eliminar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      axios
        .delete("articulo/remove", {
          data: { _id: me.articulo._id },
          headers: header,
        })
        .then(function (response) {
          me.limpiar();
          me.cerrarDialogoArticulo();
          me.listar();
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizarExistencias(_id, valor) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };

      if (
        this.articulo.existencias === "" ||
        isNaN(this.articulo.existencias) ||
        this.articulo.existencias < 0
      ) {
        this.validaMensaje.push("Existencias tiene que ser un nº entero >= 0");
        return;
      }
      axios
        .put(
          "articulo/actualizarExistencias",
          {
            _id: this.articulo._id,
            existencias: this.articulo.existencias,
            observaciones: this.observaciones,
          },
          configuracion
        )
        .then(function (response) {
          me.validaMensaje = [];
          me.listar();
          me.cerrarDialogoExistenciasArticulo();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    importarArticulosExcel(e) {
      console.log("importarArticulosExcel");
      console.log("e", e);
      console.log("$refs.file_input_articulos", this.$refs.file_input_articulos);

      try {
        let me = this;
        me.validaMensaje = [];
        const fichero_importar_articulos = e.target.files[0];
        console.log("fichero_importar_articulos", fichero_importar_articulos);
        console.log(
          "this.filtros_articulos.codigo_cliente",
          me.filtros_articulos.codigo_cliente
        );

        if (!me.filtros_articulos.codigo_cliente) {
          me.$refs.file_input_articulos.value = "";
          me.validaMensaje.push(
            "Antes de seleccionar el archivo debes indicar el código del cliente en su campo del filtro"
          );
          return;
        }

        if (!fichero_importar_articulos) {
          console.log("No hay fichero que importar");
          return;
        }

        if (fichero_importar_articulos.size > 1000000) {
          me.validaMensaje.push("El fichero no debe sobrepasar 1MB de tamaño");
          return;
        }

        let reader = new FileReader();
        reader.onload = function (e) {
          let articulos_a_importar = null;
          try {
            let data = new Uint8Array(e.target.result);
            let workbook = XLSX.read(data, { type: "array" });
            let sheetName = workbook.SheetNames[0];
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log("Conversión a json");
            console.log("me", me);
            articulos_a_importar = XLSX.utils.sheet_to_json(worksheet);
            console.log("articulos_a_importar", articulos_a_importar);
            me.validaMensaje.push("Enviando...");
          } catch (error) {
            me.$refs.file_input_articulos.value = "";
            me.validaMensaje.push("Fichero incorrecto");
            return;
          }
          console.log("fuera del try");
          me.$refs.file_input_articulos.value = "";

          if (!articulos_a_importar || articulos_a_importar.length === 0) {
            me.validaMensaje.push("Fichero incorrecto o vacío");
            return;
          }

          me.insertarMuchos(me.filtros_articulos.codigo_cliente, articulos_a_importar);

          console.log("Fin de la función");
        };

        console.log("Antes del readAsArrayBuffer");
        me.validaMensaje.push("Preparando solicitud para enviar. Espere...");
        reader.readAsArrayBuffer(fichero_importar_articulos);
      } catch (error) {
        console.error("export error", error);
      }
    },
    exportarArticulosExcel() {
      console.log("exportarArticulosExcel");
      console.log(
        "this.filtros_articulos.codigo_cliente",
        this.filtros_articulos.codigo_cliente
      );
      try {
        let articulos = [];
        this.articulos.forEach((a) => {
          console.log("a.cliente.codigo", a.cliente.codigo);
          if (
            this.filtros_articulos.codigo_cliente.length === 0 ||
            this.filtros_articulos.codigo_cliente == a.cliente.codigo
          ) {
            articulos.push({
              "Sku interno": a.sku_interno,
              "Sku cliente": a.sku_cliente,
              "Código barras": a.cod_barras,
              Nombre: a.nombre,
              Disponible: a.existencias - a.solicitado,
              Existencias: a.existencias,
              Solicitado: a.solicitado,
              Mínimo: a.minimo,
              "Precio neto": a.precio_neto,
              "Tipo Palé": a.tipoPale,
              "Unidades/Palé": a.nUnidadesPorPale,
            });
          }
        });
        let worksheet = XLSX.utils.json_to_sheet(articulos);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "articulos");
        XLSX.writeFile(new_workbook, "articulos.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    getIconEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "mdi-clipboard-list-outline";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "mdi-clipboard-alert-outline";
        case this.estados.PREPARANDO:
          return "mdi-dropbox";
        case this.estados.EMPAQUETADO:
          return "mdi-package-variant-closed";
        case this.estados.EMBARCADO:
          return "mdi-truck";
        case this.estados.CANCELADO:
          return "mdi-file-cancel-outline";
        case this.estados.INCIDENCIA:
          return "mdi-alert";
      }
    },
    getColorEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "blue";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "blue";
        case this.estados.PREPARANDO:
          return "purple";
        case this.estados.EMPAQUETADO:
          return "orange";
        case this.estados.EMBARCADO:
          return "green";
        case this.estados.CANCELADO:
          return "red";
        case this.estados.INCIDENCIA:
          return "#dcca28";
      }
      return "white";
    },
    abrirMovimientos(item) {
      console.log("abrirMovimientos articulo", item);
      this.articulo = Object.assign({}, item);
      this.filtro_remoto_movimiento_fecha_inicio = this.movimientos_fecha_inicio_inicial;
      this.filtro_remoto_movimiento_fecha_fin = this.movimientos_fecha_fin_maxima;
      console.log(
        "this.filtro_remoto_movimiento_fecha_inicio",
        this.filtro_remoto_movimiento_fecha_inicio
      );
      console.log(
        "this.filtro_remoto_movimiento_fecha_fin",
        this.filtro_remoto_movimiento_fecha_fin
      );
      this.listarMovimientos();
      this.dialog_movimiento = true;
    },
    listarMovimientos() {
      console.log("listarMovimientos");
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = {
        fecha_inicio: this.filtro_remoto_movimiento_fecha_inicio,
        fecha_fin: this.filtro_remoto_movimiento_fecha_fin,
      };

      if (!this.dialog_movimiento) {
        if (!this.filtros_articulos.codigo_cliente) {
          this.validaMensaje = [];
          this.validaMensaje.push('Completa el Código Cliente');
          return;
        }
        params.codigo_cliente = this.filtros_articulos.codigo_cliente;
      } else {
        params._id_articulo = this.articulo._id;
      }

      let configuracion = { headers: header, params: params };
      axios
        .get("movimiento_existencias/list", configuracion)
        .then(function (response) {
          me.validaMensaje = [];
          me.movimientos = response.data;
          console.log("me.movimientos", me.movimientos);
        })
        .catch(function (error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (error.response && error.response.data && error.response.data.message) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    exportarMovimientosExcel() {
      console.log("exportarMovimientosExcel");
      console.log("codigo_cliente", this.filtros_articulos.codigo_cliente);
      try {
        if (this.dialog_movimiento) {
          this.auxExportarMovimientosExcel();
          return;
        }

        if (!this.filtros_articulos.codigo_cliente || !this.filtroPrincipalMovimientoFechaInicio || !this.filtroPrincipalMovimientoFechaFin) {
          this.validaMensaje = ["Complete el Cód. Cliente y el intervalo de fechas"];
          return;
        }

        let me = this;
        let header = { Token: this.$store.state.token };
        let params = {
          fecha_inicio: this.filtroPrincipalMovimientoFechaInicio,
          fecha_fin: this.filtroPrincipalMovimientoFechaFin,
          codigo_cliente: this.filtros_articulos.codigo_cliente
        };

        let configuracion = { headers: header, params: params };
        axios
          .get("movimiento_existencias/list", configuracion)
          .then(function (response) {
            me.validaMensaje = [];
            me.movimientos = response.data;
            console.log("me.movimientos", me.movimientos);
            me.auxExportarMovimientosExcel(me.filtros_articulos.codigo_cliente);
          })
          .catch(function (error) {
            console.log("Error", error);
            let msj_error = me.$store.state.mensajes.error500;
            if (error.response && error.response.data && error.response.data.message) {
              msj_error = error.response.data.message;
            }
            me.validaMensaje = [];
            me.validaMensaje.push(msj_error);
          });
      } catch (error) {
        console.error("export error", error);
      }
    },
    auxExportarMovimientosExcel(codCliente) {
      try {
        let movimientos = [];
        this.movimientos.forEach((m) => {
          console.log("m", m);
          let movimiento = codCliente ? { "Cód. Cliente": codCliente } : {};
          movimiento = {
            ...movimiento,
            ...{
              "Rol usuario": m.usuario.rol,
              Fecha: this.formatearFecha(
                new Date(m.creacion).toISOString().substring(0, 10)
              ),
              "Rol usuario": m.usuario.rol,
              Usuario: m.usuario.nombre,
              "Email usuario": m.usuario.email,
              "Sku Interno": m.articulo.sku_interno,
              "Sku Cliente": m.articulo.sku_cliente,
              "Ref. Albarán": m.albaran ? m.albaran.cod_albaran : "",
              "Ref. Picking": m.picking_y_packing ? m.picking_y_packing.ref_cliente : "",
              "Estado Previo": m.estado_antes,
              "Estado Después": m.estado_despues,
              Variación: m.variacion,
              Existencias: m.existencias,
              "Tipo Palé": m.tipoPale,
              "u/palé": m.nUnidadesPorPale,
              "Nº Palés": m.nPalesUsados,
              Observaciones: m.observaciones,
            }
          }
          movimientos.push(movimiento);
        });
        let worksheet = XLSX.utils.json_to_sheet(movimientos);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "movimientos");
        XLSX.writeFile(new_workbook, "movimientos.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    imprimirCodigoBarras(item) {
      this.barcodeValue = item.cod_barras;
      this.dialogoCodigoBarras = true;
      let popUpAndPrint = function () {
        let svg = document.getElementById("vue-barcode-element");
        console.log("svg:", svg);
        let width = parseFloat(svg.getAttribute("width"));
        let height = parseFloat(svg.getAttribute("height"));
        var printWindow = window.open(
          "",
          "Print barcode",
          "width=" + width + ",height=" + height
        );
        printWindow.document.write(svg.innerHTML);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
      };
      setTimeout(popUpAndPrint, 1000);
    },
    cerrarDialogoArticulo() {
      this.dialog_articulo = false;
      this.limpiar();
    },
    cerrarDialogoExistenciasArticulo() {
      this.dialog_existencias_articulo = false;
      this.limpiar();
    },
    cerrarDialogMovimiento() {
      this.dialog_movimiento = false;
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>
